<template>
  <div class="fill-height">


    <v-card class="fill-height">
      <v-card-title class="p-1">
        <v-chip
            label small
            class="ma-2"
            color="secondary">
          قالب پیام ها
        </v-chip>

        <v-chip
            @click="download"
            label small
            class="ma-2"
            color="warning">
          داتلود قالب نمونه
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>

        <v-row>
          <v-col cols="12"
                 sm="2"
                 v-if="can('newTemplateSmsManager')" class="d-inline-block">
            <v-btn class="float-right "
                   color="primary"
                   right
                   fab
                   small
                   @click="forNew()"
            >
              <v-icon>fa fa-plus</v-icon>
            </v-btn>
            <create-templateSmsManager :model="model" :building-list="buildingList" :subject-items="subjectItems" :dialogStatus.sync="showDialog"/>
            <page-view :model="model"  :dialogStatus.sync="viewDialog"/>
          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="4"
                 class="d-inline-flex"
          >
            <v-text-field
                outlined
                dense
                clearable
                @click:clear="clear"
                placeholder="نام مجتمع,نام قالب"
                v-model="searchvalue"

            />
            <v-btn fab small color="primary" @click="fillDataItems" class="mr-1">
              <v-icon>mdi-cloud-search</v-icon>
            </v-btn>

          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="6" class="d-inline-block">
            <b-pagination
                v-model="skip"
                :total-rows="paging.totalSize"
                :per-page=take
                first-text="اولین"
                prev-text="<"
                next-text=">"
                last-text="آخرین"
                dir="ltr"
                limit="5"
                @change="pageChangeHandler"
            />

          </v-col>


        </v-row>


        <v-spacer/>
        <b-table
            v-if="can('templateSmsManagerList')"
            :items="dataItems"
            :fields="columns"
            :current-page="skip"
            :per-page=0
            stacked="md"
            show-empty
            striped
        >
          <template #cell(statusText)="row">
            <v-chip :color="row.item.color" label outlined small>{{ row.item.statusText }}</v-chip>
          </template>
          <template #cell(actions)="row">
            <v-btn depressed small v-if="can('editTemplateSmsManager') && row.item.status!=='Confirmed'" color="primary"
                   @click="forEdit(row.item)" class="mr-1 ">
              ویرایش
            </v-btn>
            <v-btn depressed small v-if="can('editTemplateSmsManager') && row.item.status=='Confirmed'" color="info"
                   @click="forView(row.item)" class="mr-1 ">
              مشاهده
            </v-btn>
            <v-btn depressed class="mr-1" v-if="can('deleteTemplateSmsManager')" small color="error"
                   @click="remove(row.item)">
              حذف
            </v-btn>
          </template>
        </b-table>


      </v-card-text>
    </v-card>
  </div>
</template>

<script>
/**
 * مجتمع مدیر توسط جدید پیام قالب تعریف
 */
import CreateTemplateSmsManager from './PageEdit'
import TemplateSmsManager_se from "./Servise_se";
import {mapMutations} from "vuex";
import PageView from "./PageView";


export default {
  name: 'TemplateSmsManager',
  components: {
    PageView,
    CreateTemplateSmsManager
  },
  data() {
    return {
      searchvalue: '',
      modelId: '',
      model: {},
      showDialog: false,
      viewDialog: false,
      loading: false,
      buildingList: [],
      subjectItems: [],
      dataItems: [],
      paging: {},
      skip: 1,
      take: 10,
      currentPage: 1,
      columns: [
        {key: 'building.name', label: 'مجتمع', sortable: true, sortDirection: 'desc'},
        {key: 'templateEn', label: 'نام قالب به انگلیسی', sortable: true, sortDirection: 'desc'},
        {key: 'templateFa', label: 'نام قالب به فارسی', sortable: true, sortDirection: 'desc'},
        {key: 'statusText', label: 'وضعیت', sortable: true, sortDirection: 'desc'},
        {key: 'actions', label: 'عملیات'}
      ],

    };

  },

  mounted() {
    this.$root.$on('TemplateSmsManager', () => {

      this.fillDataItems()
    })

  },

  methods: {
    close() {
      this.searchvalue = ""
      this.$router.push('/home')
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),

    fetch() {
      TemplateSmsManager_se.getById(this.modelId).then(response => {
        this.model = response.data.model
        this.buildingList = response.data.buildingItems
        this.subjectItems = response.data.subjectItems
      })
      this.showDialog = true;
    },
    forEdit: function (e) {
      this.modelId = e.id;
      this.fetch()
    },

    forNew: function () {
      this.model = {};
      this.modelId = '';
      this.fetch()
    },
    forView(e) {
      TemplateSmsManager_se.getById(e.id).then(response => {
        this.model = response.data.model
      })
      this.viewDialog = true;
    },
    remove: function (e) {
      this.$confirm()
          .then(isDestroyed => isDestroyed &&
              TemplateSmsManager_se.delete(e.id).then(response => {
                if (response && response.status === 200) {
                  this.$snack({type: 'success'})
                  this.fillDataItems()
                } else {
                  this.$snack({type: 'error'})
                }
              })
          )
    },

    pageChangeHandler: function (event) {
      this.skip = event;
      this.fillDataItems();

    },
    clear() {
      this.searchvalue = ""
      this.fillDataItems();
    },
    fillDataItems() {
      TemplateSmsManager_se.getPage(this.skip - 1, this.take, this.searchvalue).then(response => {
        if (response && response.status === 200) {
          this.paging = response.data.page
          this.dataItems = response.data.list
        }

      });
    },

    download(){
      this.loading=true;
      TemplateSmsManager_se.download().then(response => {
        this.loading=false;
        if (response && response.status === 200) {
          let blob = new Blob([response.data], {type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"})
          let url = window.URL.createObjectURL(blob)
          const link = document.createElement('a') // 创建a标签
          link.href = url;
          link.setAttribute('download', 'templateSms.xlsx'); //or any other extension
          document.body.appendChild(link);
          link.click();

        } else if (response && response.response.status === 400) {
          this.loading = false;

        }
      })
    },


  },

  created() {
    this.setDrawer(false)
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
